import apiRequest from './apiRequest';

export default async function postAdminGrantOrgCredits(payload: {
  organizationID: string;
  creditsToGrant: number;
}) {
  return apiRequest<{ organization: Record<string, unknown> }>(
    'user',
    '/admin/userManagement/grantOrgCredits',
    {
      method: 'POST',
      body: JSON.stringify(payload),
    },
  );
}
